/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bookmark-content[_ngcontent-%COMP%]{height:100%}.button-group[_ngcontent-%COMP%]{display:flex;justify-content:center;gap:50px}.bookmark-cell[_ngcontent-%COMP%], .bookmark-header[_ngcontent-%COMP%]{height:30px;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-align:center}\n/*# sourceMappingURL=feat-reference-document.component.css.map*/"];
export { styles as styles };
